import type { ReactElement } from "react";
import { Icon } from "@chakra-ui/react";
import type { IconProps } from "@chakra-ui/react";

const BlogIcon = ({
  color = "orange.500",
  ...props
}: IconProps): ReactElement => (
  <Icon viewBox="0 0 128 128" color={color} {...props}>
    <title>Blog Icon</title>
    <circle cx={64} cy={64} r={64} fill="currentColor" />
    <path
      d="M45.5 100C35.85 100 28 91.99 28 82.144V52.183C28 49.32 30.274 47 33.08 47c2.807 0 5.08 2.32 5.08 5.183v29.962c0 4.13 3.293 7.49 7.34 7.49s7.34-3.36 7.34-7.49c-.003-2.826-1.535-5.382-4.006-6.676-2.495-1.306-3.482-4.43-2.202-6.98 1.28-2.548 4.344-3.552 6.84-2.248C59.346 69.317 63 75.41 63 82.144 63 91.99 55.15 100 45.5 100z"
      fill="#fff"
    />
    <path
      d="M75.92 87c-2.806 0-5.082-2.269-5.082-5.067 0-12.18-8.702-22.651-20.69-24.89a5.068 5.068 0 01-4.061-5.909c.518-2.751 3.177-4.562 5.932-4.046C68.811 50.224 81 64.88 81 81.933A5.074 5.074 0 0175.92 87z"
      fill="#fff"
    />
    <path
      d="M94.83 87c-2.855 0-5.172-2.3-5.172-5.136 0-22.312-16.802-41.068-39.081-43.63-2.837-.327-4.868-2.874-4.543-5.69.33-2.817 2.882-4.83 5.733-4.51C79.264 31.195 100 54.337 100 81.863 100 84.7 97.686 87 94.83 87z"
      fill="#fff"
    />
  </Icon>
);

export default BlogIcon;
